// React Imports
import React, { createRef } from 'react';
import { withRouter } from 'react-router';
//import ReactGA from 'react-ga';
import Cookies from 'universal-cookie';
import classNames from "classnames"

import RequirementList from 'components/card/RequirementList/RequirementList.jsx';
import TasksList from '../../components/list/tasks/tasks.jsx';
import Modal, { Information, Confirmation, MultiOptions } from '../../components/modal/modal.jsx';
import Button from '../../components/button/button.jsx';

// UTILS
import Labels from '../../variables/labels.js';
import Helper from '../../core/helper/helper';
import { HelperSchedule } from '../schedule/core/helpers/helperSchedule.js';
import { Helmet } from 'react-helmet';
// API Imports
import {
  getClientData, getFoDetails, provideServiceFeedback, confirmGoogleReview,
  requestInvoice, getShowcaseWorkDetails, submitApproveApi, getScheduleDetails, getShowcaseWorkDetailsCal
} from '../../api/routes/api.route.js';
import ScheduleService from '../schedule/core/services/schedule.service';
import LocalData from '../../core/localData.js';
import ServiceDetailsCard from '../../components/card/service/serviceDetailsCard.jsx';
import Grid from '../../components/list/grid/grid.jsx';
import { SERVICE, GENERAL } from '../../assets/images/images.js';
import MediaFiles from '../../components/mediaFiles/MediaFiles.jsx';
import WorkChecklists from '../../components/checklist/workChecklists.jsx';
import { addClientServiceObs, addMediaFile, editPersonalServiceObs, getUploadConfig, readServiceObs, readServiceCheck, removeMediaFile } from '../../api/routes/api.route.js';
import Loader from '../../components/loader/loader.jsx';
import Emitter from '../../core/services.js';
import { analyseUrlShowcaseAnalytics, analyseUrlWorkAnalytics } from '../../core/services/analytics.service.js';
import CompanyService from '../../core/services/company.service.js';
import NotificationsService from '../../core/services/notifications.service.js';
import ConfirmAppointment from '../../components/button/ConfirmAppointment.jsx';
import { GeoLocationService } from '../../core/services/geo-localization.service';
import { ToastState } from '../../core/types.js';

// const { id, symptoms, phase, state, item, allow_cancel, allow_approve, message_toast_state,
// date_start, date_end, feedback, schedule, company_obs, client_obs, token, show_invoice_button } = data;
/**
 * ServiceData definition
 * @typedef  {Object}  ServiceData
 * @property {string}  id
 * @property {string}  token
 * @property {string}  client_obs
 * @property {string}  internal_obs
 * @property {string}  company_obs
 * @property {string}  total
 * @property {string}  total_discount
 * @property {string}  meeting_url
 * @property {Object}  symptoms
 * @property {Object}  state
 * @property {Object}  establishment
 * @property {Object}  company_extras
 * @property {Object}  client_extras
 * @property {Object[]}  checklists
 * @property {Object[]}  services
 * @property {boolean}  allow_approve
 * @property {boolean}  allow_cancel
 * @property {boolean}  is_cancelled
 * @property {boolean}  show_invoice_button
 * @property {ServiceItem}  item
 * @property {'IGNORE' | 'EXPANDED' | 'MINIMIZED'}  message_toast_state
 * @property {'IGNORE' | 'EXPANDED' | 'MINIMIZED'}  service_toast_state
 */

/**
 * ServiceItem
 * @typedef {Object} ServiceItem
 * @property {number} id
 * @property {string} image
 * @property {string} title
 * @property {string} subtitle
 */

class ServiceDetails extends React.Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.refModal = React.createRef();
    this.imageRef = React.createRef();
    this.timer = null;
    const params = new URLSearchParams(this.props.location.search);
    this.token = params.get("token") || LocalData.liteData?.token;
    this.token_cal = params.get("token_cal") || LocalData.liteData?.token_cal;
    this.isLiteVersion = Helper.isLiteVersion();
    this.isLiteWithoutToken = this.isLiteVersion && !this.token && !this.token_cal;
    this.state = {
      id: this.props.match.params.id,
      draftWorkID: undefined,
      data: null,
      serviceDetail: {},
      photos: [],
      files: undefined,
      establishment: {},
      valueRatingPrev: 0,
      observationPrev: "",
      valueRating: 0,
      observation: "",
      userData: {},
      showInvoiceButton: false,
      isAppointment:
        this.props.match.params.id?.substring(0, 2) === "S-" ||
        (this.token_cal !== undefined && this.token_cal !== null && this.token_cal !== ""),
      analyticsCalled: false,
      galleryButtonVisible: undefined,
      selectedMediaTab: null,
      confirmLoading: false,
      justSentMessage: false,
      isPaymentShinning: false,
      isConfirmShinning: false,
      fromMessageNotification: (params.get("t") === 'WCOM' || params.get("t") === 'CCOM' || params.get("t") === 'CCHA') ? true : false,
      fromConfirmNotif: (params.get("t") === 'CCNF') ? true : false,
      fromPayNotif: (params.get("t") === 'WPAY' || params.get("t") === 'CPAY') ? true : false,
      fromApproveNotif: (params.get("t") === 'WAPP') ? true : false,
      fromFeedbackNotif: params.has("feedback"),
    };
    this.notificationId = params.get("notifid");
    this.goToFeedback = params.has("feedback");
    this.galleryRef = createRef();
  }

  componentDidMount() {
    this.callAnalytics();
    this.isComponentMounted = true;
    if (this.isComponentMounted) {
      this.baseState = { ...this.state };
    }
    window.scrollTo(0, 0);
    //    ReactGA.pageview(window.location.pathname + window.location.search);
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (!this.isLiteVersion) {
      const sessionUser = LocalData.userData;
      if (sessionUser) {
        this.setState({ userData: sessionUser });
      } else {
        this.getUserData();
      }
      this.getServiceDetails();
      this.getUploadFilesTypes();
      this.updateNotifications();
    } else {
      if (this.token) {
        this.cookies.set("liteToken", this.token, Helper.cookiesLiteConfig);
      }
      if (this.token_cal) {
        this.cookies.set("liteToken", this.token_cal, Helper.cookiesLiteConfig);
      }
      if (this.email) {
        this.cookies.set("liteEmail", this.email, Helper.cookiesLiteConfig);
      }
      if (this.phone) {
        this.cookies.set("litePhone", this.phone, Helper.cookiesLiteConfig);
      }
      const companyDomain = Helper.companyDomain();
      if (!companyDomain.includes("asuaempresa")) {
        this.cookies.set("kssreturncompany", companyDomain, Helper.cookiesLiteConfig);
      }

      if (LocalData.liteData) {
        this.buildServiceDetails(LocalData.liteData);
      } else {
        if (!this.state.isAppointment) {
          this.cookies.remove("isCalToken", Helper.cookiesLiteConfig);
          if (this.token) {
            this.getShowcaseDetails(this.token, Helper.getSessionToken());
          }
        } else {
          this.cookies.set("isCalToken", true, Helper.cookiesLiteConfig); //means that we are in calendar context
          if (this.token_cal) {
            this.getShowcaseDetailsCal(this.token_cal, Helper.getSessionToken());
          }
        }
      }
    }

    this.refreshPage();

    if (Helper.isIOSWebview()) {
      try {
        window.webkit.messageHandlers.saveLastUrl.postMessage({ url: window.location.href });
      } catch (error) {
        console.error(error);
      }
    }
    if (Helper.isAndroidWebview()) {
      try {
        window.Android.saveLastUrl(window.location.href);
      } catch (error) {
        console.error(error);
      }
    }
    window.addEventListener("scroll", this.listenToScroll);
    window.addEventListener("scroll", this.handleScrollShowGalleryButton);
    setTimeout(() => {
      this.handleScrollShowGalleryButton(); // show gallery button before scroll
    }, 400);

    window.receiveLocation = (geoLocalization) => {
      this.setState({ geoLocalization });
      setTimeout(() => {
        this.getNewCompanies();
      }, 100);
    }

    setTimeout(() => {
      this.getGeolocalization();
    }, 1000);

    Emitter.on('PAYMENT_SHINNING', () => {
      this.setState({ isPaymentShinning: true });
      setTimeout(() => {
        this.setState({ isPaymentShinning: false });
      }, 1000);
    });
    if (this.state.fromConfirmNotif) {
      setTimeout(() => {
        this.setState({ isConfirmShinning: true });
      }, 1000);
      setTimeout(() => {
        this.setState({ isConfirmShinning: false });
      }, 2000);
    }
    if (this.state.fromFeedbackNotif) {
      setTimeout(() => {
        Emitter.emit('RATING_SHINNING');
      }, 1000);
    }
  }

  componentDidUpdate(prevProps) {
    this.callAnalytics();
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.isComponentMounted = true;
      if (this.isComponentMounted) {
        this.baseState = { ...this.state };
      }
      window.scrollTo(0, 0);
      //    ReactGA.pageview(window.location.pathname + window.location.search);
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (!this.isLiteVersion) {
        const sessionUser = LocalData.userData;
        if (sessionUser) {
          this.setState({ userData: sessionUser });
        } else {
          this.getUserData();
        }
        this.getServiceDetails();
        this.getUploadFilesTypes();
      } else {
        if (LocalData.liteData) {
          this.buildServiceDetails(LocalData.liteData);
        } else {
          if (!this.state.isAppointment) {
            if (this.token) {
              this.getShowcaseDetails(this.token, Helper.getSessionToken());
            }
          } else {
            if (this.token_cal) {
              this.getShowcaseDetailsCal(this.token_cal, Helper.getSessionToken());
            }
          }
        }
      }
      this.refreshPage();

      if (Helper.isIOSWebview()) {
        try {
          window.webkit.messageHandlers.saveLastUrl.postMessage({ url: window.location.href });
        } catch (error) {
          console.error(error);
        }
      }
      if (Helper.isAndroidWebview()) {
        try {
          window.Android.saveLastUrl(window.location.href);
        } catch (error) {
          console.error(error);
        }
      }
    }
  }

  componentWillUnmount() {
    Emitter.off('PAYMENT_SHINNING');
    this.isComponentMounted = false;
    if (this.timer) {
      clearTimeout(this.timer);
    }
    window.removeEventListener("scroll", this.listenToScroll);
    window.removeEventListener("scroll", this.handleScrollShowGalleryButton);
  }

  listenToScroll = () => {
    this.mobileElement = window.document.documentElement;
    const pos = this.mobileElement.scrollTop;
    const toastElem = document.querySelector(".Toastify__toast-container--top-right");
    if (pos < 60) {
      if (toastElem) {
        toastElem.style.position = "absolute";
        toastElem.style.top = "60px";
      }
    } else {
      if (toastElem) {
        toastElem.style.position = "fixed";
        toastElem.style.top = "-4px";
      }
    }
  };

  callAnalytics() {
    if (this.state.analyticsCalled) {
      return null;
    }

    if (Helper.isLiteVersion()) {
      if (LocalData.liteData?.is_client !== undefined) {
        analyseUrlShowcaseAnalytics(
          window.location.href,
          LocalData.liteData?.is_client,
          LocalData.liteData?.id
        );
        this.setState({ analyticsCalled: true });
      }
    } else {
      analyseUrlWorkAnalytics(window.location.href);
      this.setState({ analyticsCalled: true });
    }
  }

  updateNotifications = () => {
    if (this.notificationId) {
      if (!LocalData.notificationsData?.notificationsList) {
        setTimeout(() => {
          this.updateNotifications();
        }, 200);
      } else {
        NotificationsService.read(this.notificationId);
      }
    }
  };

  checkInternetConnection = () => {
    // Return a promise that resolves to true or false based on internet connectivity
    const url = `https://www.google.com/favicon.ico?${new Date().getTime()}`;
    return fetch(url, { mode: "no-cors", method: "HEAD" })
      .then(() => true) // Internet is working
      .catch(() => false); // No internet connection detected
  };

  refreshPage = () => {
    if (!this.isLiteWithoutToken) {
      this.timer = setTimeout(() => {
        // this.resetState();
        if (!this.isLiteVersion) {
          this.getUserData();
          this.getServiceDetails();
          CompanyService.getCompaniesCount();
        } else {
          if (!this.state.isAppointment) {
            if (this.token) {
              this.getShowcaseDetails(this.token, Helper.getSessionToken());
            }
          } else {
            if (this.token_cal) {
              this.getShowcaseDetailsCal(this.token_cal, Helper.getSessionToken());
            }
          }
        }
        this.refreshPage(); // Reschedule after processing the current check's result
      }, 300000);
    }
  };

  resetState = () => {
    if (this.isComponentMounted) {
      this.setState(this.baseState);
      document.body.style.overflowY = "auto";
      if (Helper.isAndroidWebview()) {
        Helper.enablePullDownToRefresh();
      }
    }
  };

  getUploadFilesTypes = () => {
    getUploadConfig(Helper.getSessionToken()).then((res) => {
      if (res?.data) {
        Helper.updateFilesAccept(res.data);
      }
    });
  };

  /**
   * Retrieves companies for a specific category and updates the state.
   * Used to access the distance to the establishment.
   * @returns {Promise<void>}
   */
  getNewCompanies = async () => {
    const { geoLocalization, establishment } = this.state;
    try {
      const companies = await CompanyService.fetchNewCompanies(null, geoLocalization);
      if (companies && establishment) {
        const company = companies.find(company => company.name === establishment.name);
        if (company) {
          this.setState(prevState => ({
            establishment: {
              ...prevState.establishment,
              distance: company.distance
            }
          }));
          LocalData.configData.companyDetails.distance = company.distance;
        }
      }
    } catch (error) {
      console.error("Error in component:", error);
    }
  };

  getGeolocalization = () => {
    // Do not request location in demo companies
    if (Helper.isDemo()) {
      return;
    }
    if (LocalData.configData?.companyDetails?.distance) {
      this.setState(prevState => ({
        establishment: {
          ...prevState.establishment,
          distance: LocalData.configData.companyDetails.distance
        }
      }));
      return;
    }
    if (Helper.isIOSWebview()) {
      try {
        window.webkit.messageHandlers.requestLocation.postMessage({});
      } catch (error) {
        console.error(error);
      }
    } else {
      this.requestLocationPermissions();
    }
  };

  requestLocationPermissions = () => {
    if (this.cookies.get('readLocationRequest', Helper.cookiesConfig) === 'true') {
      this.getBrowserLocation();
      return;
    }
    this.renderModal(
      <Information
        title={Labels.modal.modalLocation.title}
        text={Labels.modal.modalLocation.text}
        icon={GENERAL.iconLocation}
        onClick={() => {
          Helper.setCookie('readLocationRequest', true);          
          this.refModal.current.closeModal();
          this.getBrowserLocation();
        }}
        />
    );
  }

  getBrowserLocation = async () => {
    try {
      const geoLocalization = await GeoLocationService.getGeolocation();
      if (geoLocalization){
        this.setState({ geoLocalization });
        Helper.setCookie('readLocationRequest', true);
        this.refModal.current.closeModal();
        setTimeout(() => {
          this.getNewCompanies();
        }, 100);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  getAppointmentFiles = async (idParam, draftWorkIDParam) => {
    if (!this.state.isAppointment || !this.isLiteVersion || !idParam || !draftWorkIDParam) {
      return;
    }

    let _id = idParam;
    let _draftWorkID = draftWorkIDParam;
    const { id, draftWorkID } = this.state;

    if (!_id || !_draftWorkID) {
      _id = id;
      _draftWorkID = draftWorkID;
      //idParam = id;//.replace(/^S-/i, "");
    }
    try {
      const response = await ScheduleService.fetchAppointmentFiles(_id, _draftWorkID);
      if (response?.data) {
        this.setState((prevState) => ({
          ...prevState,
          files: {
            provider: response.data.company_extras,
            customer: response.data.client_extras,
          },
        }));
      } else {
        //this.renderInfoModal(response?.title, response?.body, response?.code);
      }
    } catch (error) {
      console.error("fetchAppointmentFiles [catch error]", error);
    }
  };

  /**
   * Pedido para retornar a obra a mostrar em caso de versão Lite
   *
   * @param {string} token - id para a obra
   */
  getShowcaseDetails(id, token) {
    this.cookies.remove("isCalToken", Helper.cookiesLiteConfig); 
    getShowcaseWorkDetails(id, token).then((value) => {
      if (value) {
        if (value?.code === 1 && value?.details) {
          const { item } = value.details;
          const showcaseWork = {
            ...value.details,
            item: Helper.initialItemDetailsState(item, this.isLiteVersion),
          };
          LocalData.liteData = showcaseWork;
          this.buildServiceDetails(showcaseWork);
          if (value.details.user_id) {
            this.cookies.set("userId", value.details.user_id, Helper.cookiesLiteConfig);
          }
          if (value.details.email) {
            this.cookies.set("liteEmail", value.details.email, Helper.cookiesLiteConfig);
          }
          if (value.details.phone) {
            this.cookies.set("litePhone", value.details.phone, Helper.cookiesLiteConfig);
          }
        } else if (value?.code === 5) {
          if (this.goToFeedback) {
            analyseUrlShowcaseAnalytics(window.location.href, true, value.work_id); //Send analytics before redirect
            window.location.href = `${process.env.PUBLIC_URL}/service-details/${value?.work_id}?s=I&t=0&feedback=t`;
          } else {
            analyseUrlShowcaseAnalytics(window.location.href, true, value.work_id);
            window.location.href = `${process.env.PUBLIC_URL}/service-details/${value?.work_id}?s=I&t=0`;
          }
        } else if (value?.code === 3 || value?.code === 2) {
          Emitter.emit("TOAST_LITEVERSION_DISABLE", true);
          this.renderModal(
            <Information
              title="Deseja aceder ao histórico da sua última intervenção?"
              text={Labels.liteGenericMessage(LocalData.configData?.is_scheduler_solo)}
              confirmText={Helper.getLiteRegisterButton()}
              onClick={() => {
                Helper.callLogError('getShowcaseDetails');
                Helper.logoutFromLite();
              }}
            />
          );
        } else {
          this.renderInfoModal(Labels.genericErrorTitle, value.message);
        }
      } else {
        this.renderGenericError();
      }
    });
  }

  /**
   * Pedido para retornar a obra a mostrar em caso de versão Lite
   *
   * @param {string} token - id para a obra
   */
  getShowcaseDetailsCal(id, token) {
    getShowcaseWorkDetailsCal(id, token).then((value) => {
      if (value) {
        if (value?.code === 1 && value?.details) {
          const { item, date_start, date_end } = value.details;
          const formattedDateStart = date_start
            ? ScheduleService.convertDateFromISOPendingAppointment(date_start)
            : null;
          const formattedDateEnd = date_end
            ? ScheduleService.convertDateFromISOPendingAppointment(date_end)
            : null;
          const formattedTime = date_start ? ScheduleService.getTimeFromISO(date_start) : null;
          const formattedEndTime = date_end ? ScheduleService.getTimeFromISO(date_end) : null;
          const formattedCalendarShareDateStart = date_start
            ? ScheduleService.convertDateFromISOCalendarShare(date_start)
            : null;
          const formattedCalendarShareDateEnd = date_end
            ? ScheduleService.convertDateFromISOCalendarShare(date_end)
            : null;

          const { token, ...detailsWithoutToken } = value.details;
          const showcaseWork = {
            ...detailsWithoutToken,
            date_start: formattedDateStart,
            date_end: formattedDateEnd,
            time: formattedTime,
            time_end: formattedEndTime,
            state: {
              name: HelperSchedule.getAppointmentStateBarsDescription(value.details),
              bars: 0,
            },
            shareCalendar_start_time: formattedCalendarShareDateStart,
            shareCalendar_end_time: formattedCalendarShareDateEnd,
            item: Helper.initialItemDetailsState(item, this.isLiteVersion, true),
            token_cal: token,
          };

          LocalData.liteData = showcaseWork;
          this.buildServiceDetails(showcaseWork);
          if (value.details.user_id) {
            this.cookies.set("userId", value.details.user_id, Helper.cookiesLiteConfig);
            this.cookies.set("isCalToken", true, Helper.cookiesLiteConfig); //means that we are in calendar context
          }
          if (value.details.email) {
            this.cookies.set("liteEmail", value.details.email, Helper.cookiesLiteConfig);
          }
          if (value.details.phone) {
            this.cookies.set("litePhone", value.details.phone, Helper.cookiesLiteConfig);
          }
        } else if (value?.code === 5) {
          analyseUrlShowcaseAnalytics(window.location.href, true, value.work_id); //Send analytics before redirect
          window.location.href = `${process.env.PUBLIC_URL}/service-details/${value?.work_id}?s=I&t=0`;
        } else if (value?.code === 1 && !value.details) {
          Emitter.emit("TOAST_LITEVERSION_DISABLE", true);
          if (Helper.getSessionToken()) {
            this.renderModal(
              <Information
                title="A marcação não está disponível ao cliente"
                text={""}
                confirmText={"Voltar à minha conta"}
                onClick={() => (window.location.href = `${process.env.PUBLIC_URL}`)}
              />
            );
          } else {
            this.renderModal(
              <Information
                title="A marcação não está disponível ao cliente"
                text={""}
                confirmText={"Fechar"}
                onClick={() => {
                  this.refModal.current.closeModal();
                  this.props.history.push("/services-lite");
                  }
                }
              />
            );
          }
        } else {
          this.renderInfoModal(Labels.genericErrorTitle, value.message);
        }
      } else {
        this.props.history.push(`/services`);
      }
    });
  }

  /**
   * Pedido para obter dos dados do cliente
   */
  getUserData = () => {
    getClientData(Helper.getSessionToken()).then((value) => {
      if (value) {
        if (!value.code) {
          LocalData.userData = value;
          this.setState({ userData: null });
          this.setState({ userData: value });
          this.forceUpdate();
        }
      }
    });
  };

  /**
   * Lida com a resposta a um request quando existe value code
   */
  handleValueCodeResponse = (value) => {
    if (value.code === 401) {
      Helper.callLogError("401 getServiceDetails ");
      return;
    } else if (value.code === 404) {
      this.props.history.push(`/services`);
    } else if (value.code === 409) {
      this.renderModal(
        <Information
          title="Acesso Não Autorizado"
          text={value.message}
          onClick={() => {
            this.refModal.current.closeModal();
            this.props.history.push(`/services`);
          }}
        />
      );
    } else if (value.code === 406) {
      this.renderInfoModal("Formato Inválido", value.message);
    } else if (value.code === 301) {
      if (this.goToFeedback) {
        this.props.history.replace(`/service-details/${value.id}?s=I&t=0&feedback=t`);
      } else {
        this.props.history.replace(`/service-details/${value.id}?s=I&t=0`);
      }
    } else {
      this.renderModal(
        <Information
          title="Pedido Sem Sucesso"
          text="Foi encontrado um problema durante o pedido, por favor tente mais tarde"
          onClick={() => {
            this.refModal.current.closeModal();
            this.props.history.push(`/services`);
          }}
        />
      );
    }
  };

  buildServiceDetails = (/** @type {ServiceData} */ data) => {
    /** @type {ServiceData} */
    const is_product_services = LocalData.configData.worksheet_operational === "false";
    const {
      id,
      symptoms,
      phase,
      state,
      item,
      allow_cancel,
      allow_approve,
      service_toast_state,
      message_toast_state,
      payment_toast_state,
      date_start,
      old_date,
      date_end,
      time,
      time_end,
      old_time,
      feedback,
      schedule,
      client_obs,
      internal_obs,
      token,
      token_cal,
      show_invoice_button,
      shareCalendar_start_time,
      shareCalendar_end_time,
      is_cancelled,
      is_history,
      work_id,
      draft_work_id,
      chat,
      allow_confirmation,
      meeting_url,
      payment,
      checklists,
      is_confirmed,
      is_group,
      client_arrived,
      payment_value,
      credit_value,
      full_day
    } = data;

    const missedAppointment = !work_id && !is_cancelled && is_history && this.state.isAppointment && !client_arrived;
    const hasCreditValue = credit_value && credit_value !== "0,00";
    const paymentStateDescription = hasCreditValue
                                    ? "Pendente de Pagamento"
                                    : !payment || !payment.state || payment.state === "PAYED" 
                                      ? null 
                                      : this.state.isAppointment || state.bars === 4 || (is_product_services && state.bars === 3)
                                          ? "Pendente de Pagamento"
                                          : null;
                                       
    /** @type {ServiceItem} */
    const serviceDetails = {
      total: data.total,
      total_novat: data.total_novat,
      totalDiscount: data.total_discount,
      items: data.services,
      companyObs: chat,
    };
    // this.setState({ data: null });
    this.setState({
      id: id,
      draftWorkID: draft_work_id,
      serviceDetail: serviceDetails,
      files: {
        provider: data?.company_extras,
        customer: data?.client_extras,
      },
      establishment: data.establishment,
      data: {
        symptoms: symptoms,
        item: item,
        phase: phase,
        state: {
          bars: state?.bars,
          name: paymentStateDescription ? paymentStateDescription 
              : state?.name,
        },
        allowCancel: allow_cancel,
        is_cancelled: is_cancelled,
        is_confirmed: is_confirmed,
        isGroup: !!is_group,
        is_history: is_history,
        allowApprove: allow_approve,
        dateStart: date_start,
        old_date: old_date,
        dateEnd: date_end,
        old_time: old_time,
        time: time,
        time_end: time_end,
        full_day: full_day,
        shareCalendar_start_time: shareCalendar_start_time,
        shareCalendar_end_time: shareCalendar_end_time,
        schedule: schedule,
        feedback: feedback,
        clientObs: client_obs,
        internalObs: internal_obs,
        showInternalNotes: !!internal_obs,
        checkoutInfo: data?.exit_kms,
        token,
        token_cal,
        showUnreadCheck: service_toast_state === "EXPANDED",
        showUnreadMessage: message_toast_state === "EXPANDED",
        showPaymentAction: payment_toast_state === ToastState.EXPANDED,
        hasMessage: message_toast_state !== "IGNORE" && !this.isLiteVersion,
        missedAppointment: missedAppointment,
        allowConfirm: allow_confirmation,
        obsHistory: chat ?? null,
        meetingUrl: meeting_url,
        payment: payment,
        payment_value: payment_value,
        credit_value: credit_value,
        checklists: Array.isArray(checklists) ? checklists : [],
        work_id: work_id,
        // obsHistory: [
        //   { type: "COMPANY", date: "2024-10-01T08:30:00Z", message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." },
        //   { type: "CLIENT", date: "2024-10-02T09:45:00Z", message: "Suspendisse eget velit non magna ultricies feugiat." },
        //   { type: "COMPANY", date: "2024-10-03T10:15:00Z", message: "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua." },
        //   { type: "CLIENT", date: "2024-10-04T11:30:00Z", message: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip." },
        //   { type: "COMPANY", date: "2024-10-05T12:00:00Z", message: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore." },
        //   { type: "CLIENT", date: "2024-10-06T13:20:00Z", message: "Fugiat nulla pariatur excepteur sint occaecat cupidatat non proident." },
        //   { type: "COMPANY", date: "2024-10-07T14:45:00Z", message: "Sunt in culpa qui officia deserunt mollit anim id est laborum." },
        //   { type: "CLIENT", date: "2024-10-08T15:30:00Z", message: "Integer nec odio. Praesent libero. Sed cursus ante dapibus diam." },
        //   { type: "COMPANY", date: "2024-10-09T16:10:00Z", message: "Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora." },
        //   { type: "CLIENT", date: "2024-10-10T17:00:00Z", message: "Curabitur sodales ligula in libero. Sed dignissim lacinia nunc." }
        // ],
      },
      valueRating: Helper.printRating(feedback),
      observation: Helper.printObserv(feedback),
      valueRatingPrev: Helper.printRating(feedback),
      observationPrev: Helper.printObserv(feedback),
      showFeedback: Boolean(!feedback),
      showInvoiceButton: show_invoice_button,
    });
    this.getAppointmentFiles(id, draft_work_id);
  };

  /**
   * Pedido para devolver details do serviço de uma equipamento especifica
   */
  getServiceDetails() {
    const { match } = this.props;
    if (match.params.id && match.params.id.substring(0, 2) === "S-") {
      const appointmentId = match.params.id;
      getScheduleDetails(Helper.getSessionToken(), appointmentId).then((value) => {
        if (value) {
          if (value.code) {
            this.handleValueCodeResponse(value);
          } else {
            const { token, ...valueWithoutToken } = value;
            const updatedValue = {
              ...valueWithoutToken,
              state: {
                name: HelperSchedule.getAppointmentStateBarsDescription(value),
                bars: value.state.bars,
              },
              token_cal: token,
            };
            this.buildServiceDetails(updatedValue);
          }
        }
      });
    } else {
      getFoDetails(match.params.id, Helper.getSessionToken()).then((value) => {
        if (value) {
          if (value.code) {
            this.handleValueCodeResponse(value);
          } else {
            this.buildServiceDetails(value);
          }
        }
      });
    }
  }

  ratingValueHandle = (value) => {
    this.setState({ valueRating: value });
  };

  /**
   * Pedido para retornar dos os seriços que foram agendados
   *
   * @param {number} id - id do serviço
   * @param {string} feedback - objecto com o feedback (rating, observação)
   */
  serviceFeedback = (id, feedback) => {
    return provideServiceFeedback(Helper.getSessionToken(), id, feedback)
      .then((value) => {
        if (value) {
          if (value.code) {
            this.renderModal(
              <Information
                title="Pedido Sem Sucesso"
                text={value.message}
                onClick={() => {
                  this.setState({
                    observation: this.state.observationPrev,
                    valueRating: this.state.valueRatingPrev,
                  });
                  this.refModal.current.closeModal();
                }}
              />
            );
            return false;
          } else {
            this.getServiceDetails();
            if (!this.promptGoogleReview(value, () => {})) {
              // No Google prompt — just success
            }
            return true;
          }
        } else {
          this.renderGenericError();
          return false;
        }
      })
      .catch(() => {
        this.renderGenericError();
        return false;
      });
  };

  /**
   * Confirmação de pedir faturação
   */
  confirmSubmitInvoice() {
    if (this.isLiteVersion) {
      this.renderModal(
        <Information
          title={Labels.liteSendInvoiceTitle}
          text={Labels.liteGenericMessage(LocalData.configData?.is_scheduler_solo)}
          confirmText={Helper.getLiteRegisterButton()}
          onClick={() => {
            Helper.callLogError('confirmSubmitInvoice from Lite');
            Helper.logoutFromLite();
          }}
        />
      );
      return;
    }
    const { userData } = this.state;
    if (!userData.invoice_primary && !userData.invoice_secondary) {
      this.renderInfoModal("Atenção", Labels.warningSendInvoiceMessage);
    } else {
      this.renderModal(
        <Confirmation
          title="Atenção"
          text={Labels.confirmSendInvoice}
          confirmText="Enviar"
          confirmationHandle={() => this.submitInvoice()}
          declineHandle={() => this.refModal.current.closeModal()}
        />
      );
    }
    this.refModal.current.openModal();
  }

  submitInvoice = () => {
    const { userData, id } = this.state;
    const emails = [];
    if (userData.invoice_primary) {
      emails.push(userData.email);
    }
    if (userData.invoice_secondary) {
      emails.push(userData.secondary_email);
    }
    this.refModal.current.closeModal();
    const body = { emails: emails };
    requestInvoice(id, Helper.getSessionToken(), body).then((value) => {
      if (value) {
        if (value.code) {
          this.renderGenericError();
        } else {
          this.renderInfoModal("Pedido efectuado com Sucesso", value.message);
        }
      } else {
        this.renderGenericError();
      }
    });
  };

  confirmAllowApprove() {
    if (this.isLiteVersion) {
      this.renderModal(
        <Information
          title={Labels.liteApproveBudgetTitle}
          //text={Labels.liteGenericMessage}
          confirmText={Helper.getLiteRegisterButton()}
          onClick={() => {
            Helper.callLogError('confirmAllowApprove from Lite');
            Helper.logoutFromLite();
          }}
        />
      );
      return;
    }
    this.renderModal(
      <Confirmation
        title={Labels.confirmApproveBudgetTitle}
        text={Labels.confirmApproveBudget(this.state.serviceDetail.total)}
        confirmText={Labels.confirm}
        confirmationHandle={() => {
          this.refModal.current.closeModal();
          this.submitApprove();
        }}
        declineHandle={() => this.refModal.current.closeModal()}
      />
    );
  }

  submitApprove = () => {
    const { id } = this.state;
    submitApproveApi(id, Helper.getSessionToken()).then((value) => {
      if (value) {
        if (value.code) {
          this.renderGenericError();
        } else {
          this.renderModal(
            <Information
              title={Labels.modal.approvedBudget.title}
              text={value.message}
              onClick={() => {
                this.refModal.current.closeModal();
                this.buildServiceDetails(value);
              }}
            />
          );
        }
      } else {
        this.renderGenericError();
      }
    });
  };

  /**
   * Shows a merged "Feedback Enviado" + Google review prompt if applicable.
   * @returns {boolean} true if Google prompt was shown, false otherwise
   */
  promptGoogleReview = (response, onDismiss) => {
    if (response.google_review_url && response.google_review_stars >= 4) {
      const isFirst = response.is_first_google_review !== false;
      this.renderModal(
        <Confirmation
          title={response.message || 'Feedback Enviado'}
          text={isFirst ? "Pontuar também no Google?" : "A sua avaliação melhorou!"}
          subText={isFirst ? null : "Atualizar o feedback no Google?"}
          confirmText="Sim"
          cancelText="Não"
          confirmationHandle={() => {
            window.open(response.google_review_url, '_blank');
            confirmGoogleReview(Helper.getSessionToken(), response.google_review_stars).catch(() => {});
            this.refModal.current.closeModal();
            if (onDismiss) onDismiss();
          }}
          declineHandle={() => {
            this.refModal.current.closeModal();
            if (onDismiss) onDismiss();
          }}
        />
      );
      return true;
    }
    return false;
  }

  validateFeedbackSubmition = (feedback) => {
    const { id } = this.state;
    if (!this.isLiteVersion) {
      return this.serviceFeedback(id, feedback).then((success) => {
        if (success) {
          CompanyService.getCompaniesCount();
          return true;
        }
        return false;
      });
    } else {
      this.renderModal(
        <Information
          title={Labels.liteSendFeedbackTitle}
          //text={Labels.liteGenericMessage}
          confirmText={Helper.getLiteRegisterButton()}
          onClick={() => {
            Helper.callLogError('validateFeedbackSubmition from Lite');
            Helper.logoutFromLite();
          }}
        />
      );
      return false;
    }
  };

  updateSelectedMediaTab = (value) => {
    this.setState({ selectedMediaTab: value });
  };

  renderFilesSection = () => {
    if (this.state.isAppointment && !this.state.draftWorkID) return null;
    const {
      files,
      data: { state },
      selectedMediaTab,
    } = this.state;
    const styleClass = "mt-3 mt-md-4";
    return (
      <div ref={this.galleryRef}>
        <MediaFiles
          key="media-files" // Ensure the key remains stable unless you need to force a remount
          data={{ files, state }}
          styleClass={styleClass}
          newMediaFileLoaded={this.newMediaFileLoaded}
          onDeleteMediaFile={this.deleteMediaFile}
          selectedTab={selectedMediaTab}
          onSelectedTabChange={this.updateSelectedMediaTab}
        />
      </div>
    );
  };

  deleteMediaFile = (id) => {
    this.renderModal(
      <Confirmation
        title="Atenção"
        text={Labels.confirmRemoveFile}
        confirmText="Remover"
        confirmationHandle={() => {
          this.renderModal(
            <Loader
              message="O seu ficheiro está a ser apagado..."
              inverted={false}
              local={true}
              big={false}
            ></Loader>
          );
          removeMediaFile(Helper.getSessionToken(), this.props.match.params.id, id).then(
            (value) => {
              if (value) {
                if (value.code) {
                  this.handleValueCodeResponse(value);
                } else {
                  this.renderModal(
                    <Information
                      title={"Concluído!"}
                      text={value.message}
                      onClick={() => {
                        this.refModal.current.closeModal();
                        this.getServiceDetails();
                      }}
                    />
                  );
                }
              } else {
                this.renderGenericError();
              }
            }
          );
        }}
        declineHandle={() => this.refModal.current.closeModal()}
      />
    );
  };

  newMediaFileLoaded = (file, thumbnail) => {
    let formData = new FormData();
    formData.append("media", file, file.name);
    if (thumbnail) {
      formData.append("thumbnail", thumbnail, file.name);
    }
    this.renderModal(
      <Loader
        message="O seu ficheiro está a ser carregado..."
        inverted={false}
        local={true}
        big={false}
      ></Loader>
    );

    const serviceId = this.state.id;
    //const serviceId = this.state.draftWorkID ? "S-" + this.state.draftWorkID : this.state.id;

    //addMediaFile(Helper.getSessionToken(), this.props.match.params.id, formData).then(value => {
    addMediaFile(Helper.getSessionToken(), serviceId, formData).then((value) => {
      this.refModal.current.closeModal();
      if (value) {
        if (value.code) {
          this.handleValueCodeResponse(value);
        } else {
          this.renderModal(
            <Information
              title={"Concluído!"}
              text={value.message}
              onClick={() => {
                this.refModal.current.closeModal();
                this.getServiceDetails();
              }}
            />
          );
        }
      } else {
        this.renderGenericError();
      }
    });
  };

  handleOnReadMessage = () => {
    readServiceObs(this.props.match.params.id, Helper.getSessionToken()).then((res) => {
      if (res.code) {
        return;
      }
      this.setState(prevState => ({
        data: {
          ...prevState.data,
          showUnreadMessage: false,
        },
      }));
    });
  };

  handleOnReadCheck = () => {
    readServiceCheck(this.props.match.params.id, Helper.getSessionToken()).then((res) => {
      if (res.code) {
        return;
      }
      this.getServiceDetails();
    });
  };

  renderServiceDetailsCard = () => {
    const { id, data, establishment, isAppointment, fromMessageNotification, fromApproveNotif, fromPayNotif } = this.state;
    return (
      <ServiceDetailsCard
        data={{ ...data, id, establishment, isAppointment, fromMessageNotification, fromApproveNotif, fromPayNotif }}
        isLiteVersion={this.isLiteVersion}
        location={this.props.location}
        history={this.props.history}
        callback={this.validateFeedbackSubmition}
        onReadMessage={() => this.handleOnReadMessage()}
        onReadCheck={() => this.handleOnReadCheck()}
      />
    );
  };

  renderTasksList = () => {
    //if (this.state.isAppointment) return;
    const {
      serviceDetail,
      data: { state, allowApprove, credit_value, payment_value },
      showInvoiceButton,
    } = this.state;
    return (
      <TasksList
        title="Detalhes do Serviço"
        allowApprove={allowApprove}
        data={serviceDetail}
        state={state.bars}
        invoiceEmail={showInvoiceButton}
        submitInvoice={() => this.confirmSubmitInvoice()}
        onAllowApprove={() => this.confirmAllowApprove()}
        isAppointment={this.state.isAppointment}
        credit_value={credit_value}
        payment_value={payment_value}
        renderAfterPaymentRow={!this.state.isAppointment ? () => this.renderPaymentButton() : undefined}
      />
    );
  };

  handleCalendarEventShare = (appointment) => {
    if (
      Helper.isAndroidWebview() ||
      Helper.isIOSWebview() ||
      Helper.isAndroidBrowser() ||
      Helper.isIOS()
    ) {
      HelperSchedule.createICalAndShare(
        ScheduleService.convertCardDataToCalendarShare(appointment)
      );
      return;
    }
    this.refModal.current.renderView(
      <MultiOptions
        title="Adicionar a Outros Calendários"
        option1Text="Calendário Google"
        icon1={GENERAL.iconGoogle}
        option2Text="Calendário Apple"
        icon2={GENERAL.iconApple}
        option3Text="Calendário Outlook"
        icon3={GENERAL.iconOutlook}
        handleOption1={() => {
          HelperSchedule.createGoogleCalendarUrl(
            ScheduleService.convertCardDataToCalendarShare(appointment)
          );
        }}
        handleOption2={() => {
          HelperSchedule.createICalAndShare(
            ScheduleService.convertCardDataToCalendarShare(appointment)
          );
        }}
        handleOption3={() => {
          HelperSchedule.createICalAndShare(
            ScheduleService.convertCardDataToCalendarShare(appointment)
          );
        }}
      />
    );
    this.refModal.current.openModal();
  };

  renderCalendarEventShare = (size) => {
    if (!this.state.isAppointment) return;
    const appointment = this.state;
    const margin = this.state.hasDiscount ?
      "mt-2" :
      size === 'small' ?
        "mt-3" :
        "mt-4";

    const buttonClass = size === 'small'
      ? 'cta-button-secondary d-sm-medium w-75 inline-flex-center white'
      : 'cta-button-secondary d-medium d-sm-large w-100 px-4 inline-flex-center white';
    return (
      <div className={`${margin}`}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "349px" }}>
            <Button
              className={buttonClass}
              type="iconAndText"
              value="Adicionar a Outros Calendários"
              icon={SERVICE.calendar}
              onClick={() => this.handleCalendarEventShare(appointment)}
            />
          </div>
        </div>
      </div>
    );
  };

  renderPaymentButton = () => {
    const payment = this.state.data.payment?.state;
    const paymentValue = this.state.data.payment_value;
    const hasPendingPaymentValue = paymentValue && paymentValue !== "0,00";
    const {isPaymentShinning} = this.state;
    if ((!payment && !hasPendingPaymentValue) || payment === 'PAYED' || (this.state.data.state.bars === 5 && !hasPendingPaymentValue)) return;

    const appointment = this.state;
    const margin = "mt-1"; //this.state.hasDiscount ? "mt-2" : "mt-4";
    return (
      <div className={`${margin}`}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "349px" }}>
            <Button
              className={`cta-button-primary d-medium d-sm-large w-100 px-4 flex-center mt-0 mt-sm-2 ${isPaymentShinning ? 'shinning' : ''}`}
              type="iconAndText"
              value="Efetuar Pagamento"
              //icon={SERVICE.calendar}
              onClick={() => {
                if (this.isLiteVersion) {
                  this.renderModal(
                    <Information
                      title={"Deseja efetuar o pagamento?"}
                      confirmText={Helper.getLiteRegisterButton()}
                      onClick={() => {
                        Helper.callLogError('renderPaymentButton from Lite');
                        Helper.logoutFromLite();
                      }}
                    />
                  );
                  return;
                } else {
                  this.props.history.push(`/payment/${appointment.id}`)
                }
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  renderPaymentStatus = () => {
    // if (!this.state.isAppointment) return;
    const payment = this.state.data.payment;
    const paymentState = this.state.data.payment?.state;
    if (!payment) return;
    const valid_until = this.state.data.payment?.valid_until;
    const paymentMethod = (paymentState === 'PAYED' && payment.method) ? payment.method : null;
    const paymentDate = (paymentState === 'PAYED' && payment.payment_date) ? payment.payment_date : null;
    const paymentDocumentLink = (paymentState === 'PAYED' && payment.payment_work_id) ? payment.payment_work_id : null;
    const isAppointment = this.state.isAppointment;

    if (paymentState !== 'PAYED') {
      return (
        <div>
          {valid_until && <div className='mb-0 mt-4'>Evite o cancelamento desta reserva<br />Pague até <strong>{valid_until}</strong></div>}
        </div>
      );
    }
    if (paymentState === 'PAYED') {
      return (
        <div>
          <div>
            {paymentDate &&
              <div className="mb-0 mt-4" style={{ fontSize: "16px" }}>
                Pago {paymentMethod ? `por ${paymentMethod} ` : ''}a {paymentDate}
              </div>
        }
          </div>
          {paymentDocumentLink &&
            <div className={`mb-0 mt-2`}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div >
                  <div
                    role={"button"}
                    onClick={() => window.location.href = `${process.env.PUBLIC_URL}/service-details/${paymentDocumentLink}?s=I&t=0`}
                    style={{ zIndex: 200 }}
                  >
                    <span className="link-container-span">{isAppointment ? Labels.payment.linkToWork : Labels.payment.linkToSchedule}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      );
    }
  }

  renderLinkToWork = () => {
    const { data: { work_id }, isAppointment } = this.state;
    if (!work_id || !isAppointment) return null;
    return (
      <div className="mb-0 mt-4">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div>
            <div
              role={"button"}
              onClick={() => window.location.href = `${process.env.PUBLIC_URL}/service-details/A-${work_id}?s=I&t=0`}
              style={{ zIndex: 200 }}
            >
              <span className="link-container-span">
                {Labels.linkToWork}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  onClickShareVideoCall = () => {
    const { data: { meetingUrl } } = this.state;
    const shareLink = meetingUrl;
    const shareData = {
      title: 'Partilhar link para Videochamada',
      text: '',
      url: shareLink
    };
    this.openShareNavigator(shareData);
  };

  openShareNavigator(shareData) {
    const title = shareData.title;
    const text = shareData.text;
    const url = shareData.url;
    if (navigator.share) {
      navigator.share(shareData).then(() => { })
        .catch(console.error);
    } else if (Helper.isAndroidWebview()) {
      try {
        window.Android.enableShareMenu(title, text, url);
      } catch (error) {
        console.error(error);
      }
    } else if (Helper.isIOSWebview() && !window.MSStream) {
      try {
        window.webkit.messageHandlers.enableShareMenu.postMessage({ title, text, url });
      } catch (error) {
        console.error(error);
      }
    }
    else {
      this.renderModal(
        <Information
          title={Labels.shareMeeting.copyAsk}
          confirmText={Labels.shareMeeting.confirm}
          onClick={() => {
            this.refModal.current.closeModal();
            return this.copyLink(shareData);
          }}
        />
      );
    }
  }

  renderVideoCallButton = (size = undefined) => {
    const { data: { meetingUrl } } = this.state;
    const notRender = !meetingUrl;
    const margin = size === 'small' ? "mt-2" : "mt-3";
    const className = classNames("cta-button-secondary white inline-flex-center justifyItems-center",
      {
        "d-sm-medium w-100": size === "small",
        "d-medium d-sm-large w-100 px-4": !size
      });
    return notRender ? null : (
      <div className={`${margin}`} style={{justifyItems: "center"}}>
        <div className={`videoCall-button-container-center ${size === 'small' ? 'small' : ''}`}>
          <div className={`videoCall-button-container-center-content ${size === 'small' ? 'small' : ''}`}>
            <Button
              className={className}
              type="iconAndText"
              title={`Abrir link para Videochamada`}
              value={`Videochamada`}
              icon={GENERAL.iconVideoCall}
              onClick={() => window.open(meetingUrl, "_blank")}
              styleMain={{width: "100%"}}
            />
            <div className={`share-button-container mt-2 mb-1 ${size === 'small' ? 'small' : ''}`}>
              <div role={'button'} className={`share-icon d-flex ${size === 'small' ? 'small' : ''}`} onClick={this.onClickShareVideoCall}>
                <img src={GENERAL.share} alt="share-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderConfirmButton = () => {
    if (!this.state.isAppointment || !this.state.data.allowConfirm) return;
    if (this.state.data.isGroup) return;
    const appointmentId = this.state.id.substring(2);
    const margin = this.state.hasDiscount ? "mt-2" : "mt-4";
    const {isConfirmShinning} = this.state;

    return (
      <div className={`${margin}`}>
        <ConfirmAppointment
          appointmentId={appointmentId}
          token_cal={this.token_cal}
          onRenderInfoModal={(title, message) => this.renderInfoModal(title, message)}
          onConfirmation={() => {
             this.setState(prevState => ({
               data: {
                 ...prevState.data,
                 allowConfirm: false,
               }
             }));
            setTimeout(() => {
              if (this.isLiteVersion) {
                this.getShowcaseDetailsCal(this.token_cal, Helper.getSessionToken());
              } else {
                this.getServiceDetails();
              }
            }, 200);
          }}
          isConfirmShinning={isConfirmShinning}
        />
      </div>
    )
  };

  renderCancelAppointment = () => {
    if (!this.state.isAppointment || !this.state.data.allowCancel) return;
    if (this.state.data.isGroup) return;
    const appointmentId = this.state.id.substring(2);
    const margin = this.state.hasDiscount ? "mt-2" : "mt-2";
    return (
      <div className={`mb-3 ${margin}`}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div >
            <div
              role={"button"}
              onClick={() => this.handleCancelAppointment(appointmentId)}
              style={{ zIndex: 200 }}
            >
              <span className="link-container-span small">Cancelar Marcação
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  handleCancelAppointment = (appointmentId) => {
    this.refModal.current.renderView(
      <Confirmation
        title="Cancelar Marcação"
        text="Deseja cancelar a marcação?"
        cancelText="Voltar atrás"
        confirmationHandle={() => this.handleCancelAppointmentAction(appointmentId)}
        declineHandle={() => this.refModal.current.closeModal()}
      />
    );
    this.refModal.current.openModal();
  };

  handleCancelAppointmentAction = (appointmentId) => {
    try {
      ScheduleService.deleteAppointment(appointmentId).then((response) => {
        if (response?.success) {
          this.refModal.current.closeModal();
          // Emitter.emit("APPOINTMENTS_COUNT");
          CompanyService.getCompaniesCount();
          this.getServiceDetails();
        } else {
          this.renderInfoModal(response?.title, response?.body);
        }
      });
    } catch (error) {
      console.error("handleScheduleConfirmation [catch error]", error);
    }
  };

  renderRequirements = () => {
    const {
      justSentMessage,
      data: { symptoms, clientObs, is_cancelled, is_history, obsHistory, showUnreadMessage, isGroup },
    } = this.state;

    const chat = Array.isArray(obsHistory) && obsHistory.length > 0;
    const unreadCounter = (chat && showUnreadMessage) ? obsHistory.filter(
      (message) => message.type === 'COMPANY' && !message.read_date
    ).length : 0;

    const renderGridContent = () => {
      return <RequirementList symptoms={symptoms} />;
    };
    return (
      <Grid
        styleClass="mt-3 mt-lg-0 mb-0 pt-0"
        title={isGroup ? Labels.cardCategoriaDetailsTitleGroup : Labels.cardCategoriaDetailsTitle}
        isGroup={isGroup}
        status={!chat || justSentMessage}
        icon={GENERAL.listIcon}
        hasObservationItem={true}
        hasSymptoms={symptoms?.length > 0}
        obsType={'message'}
        obsData={{
          observations: clientObs,
          history: obsHistory,
          readOnly: (Helper.isLiteVersion() || (this.state.isAppointment && (is_cancelled || is_history))),
          noClickAction: (!Helper.isLiteVersion() && this.state.isAppointment && (is_cancelled || is_history))
        }}
        onSaveObservation={(val) => this.saveRequirementObservation(val)}
        onReadMessage={() => this.handleOnReadMessage()}
        counterAlert={unreadCounter}
        isHistoryAppointment={this.state.isAppointment && is_history}
      >
        {renderGridContent()}
      </Grid>
    );
  };

  saveRequirementObservation = (val) => {
    const { id } = this.state;
    const isAppointment = this.state.isAppointment;

    const currentDatetime = new Date().toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(',', '');

    if (isAppointment) {
      ScheduleService.updateAppointmentObs(id, val).then((value) => {
        if (value) {
          if (value.code || value.error) {
            //this.handleValueCodeResponse(value);
            this.renderGenericError();
            Emitter.emit("OBS_MESSAGE_SENT_LOADING", "error");
          } else {
            this.setState(prevState => ({
              justSentMessage: true,
              data: {
                ...prevState.data,
                hasMessage:true,
                obsHistory: [
                  ...prevState.data.obsHistory,
                  {
                    message: val,
                    type: 'CLIENT',
                    date: currentDatetime
                  }
                ]
              }
            }));
            Emitter.emit("OBS_MESSAGE_SENT_LOADING", "success");
          }
        } else {
          this.renderGenericError();
          Emitter.emit("OBS_MESSAGE_SENT_LOADING", "error");
        }
      });
    } else {
      addClientServiceObs(id, Helper.getSessionToken(), { message: val }).then(value => {
        if (value) {
          if (value.code || value.error) {
            this.renderGenericError();
            Emitter.emit("OBS_MESSAGE_SENT_LOADING", "error");
          } else {
            this.setState(prevState => ({
              justSentMessage: true,
              data: {
                ...prevState.data,
                hasMessage:true,
                obsHistory: [
                  ...prevState.data.obsHistory,
                  {
                    message: val,
                    type: 'CLIENT',
                    date: currentDatetime
                  }
                ]
              }
            }));
            Emitter.emit("OBS_MESSAGE_SENT_LOADING", "success");
          }
        } else {
          this.renderGenericError();
          Emitter.emit("OBS_MESSAGE_SENT_LOADING", "error");
        }
      });
    }
  }

  renderInternalObs = () => {
    const {
      data: { internalObs },
    } = this.state;

    return (
      <Grid
        styleClass="mt-4 mb-0 pt-0"
        title={Labels.cardPersonalNotesTitle}
        status={internalObs}
        icon={GENERAL.notesIcon}
        hasObservationItem={true}
        hasSymptoms={false}
        obsType={"internal"}
        obsData={{ observations: internalObs, readOnly: Helper.isLiteVersion() }}
        onSaveObservation={(val) => this.saveInternalObs(val)}
      ></Grid>
    );
  };

  renderChecklists = () => {
    const { data } = this.state;

    if (!data?.checklists?.length) {
      return null;
    }

    return <WorkChecklists checklists={data.checklists} />;
  };

  saveInternalObs = (val) => {
    const { id } = this.state;
    editPersonalServiceObs(id, Helper.getSessionToken(), { obs: val }).then((data) => {
      if (data) {
        if (data.code) {
          this.handleValueCodeResponse(data);
        } else {
          this.getServiceDetails();
        }
      } else {
        this.renderGenericError();
      }
    });
  };

  renderGenericError = () => {
    this.renderInfoModal(Labels.genericErrorTitle, Labels.genericErrorMessage);
  };

  renderInfoModal = (title, message) => {
    this.renderModal(
      <Information
        title={title}
        text={message}
        onClick={() => this.refModal.current.closeModal()}
      />
    );
  };

  renderModal = (view) => {
    this.refModal.current.renderView(view);
    this.refModal.current.openModal();
  };

  handleScrollShowGalleryButton = () => {
    if (this.galleryRef.current) {
      const galleryRect = this.galleryRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (
        galleryRect.top <= windowHeight - 120 ||
        window.scrollY + windowHeight >= document.documentElement.scrollHeight
      ) {
        if (this.state.galleryButtonVisible) {
          this.setState({ galleryButtonVisible: false });
        }
      } else {
        if (!this.state.galleryButtonVisible) {
          this.setState({ galleryButtonVisible: true });
        }
      }
    }
  };

  scrollToGallery = () => {
    if (this.galleryRef.current) {
      const galleryTop = this.galleryRef.current.offsetTop - 10;
      window.scrollTo({
        top: galleryTop,
        behavior: "smooth",
      });
    }
  };

  renderMediaIcon = () => {
    const { files, galleryButtonVisible } = this.state;
    const isMediaFiles =
      files?.customer?.documents?.length +
      files?.customer?.media?.length +
      files?.provider?.documents?.length +
      files?.provider?.media?.length >
      0;
    if (!isMediaFiles || !galleryButtonVisible) return null;
    return (
      <div className="media-button" onClick={this.scrollToGallery}>
        <img className={"icon-container"} src={GENERAL.mediaIcon} alt="mediaIcon" />
        <img className={"icon-container small"} src={GENERAL.iconSmallArrowDown} alt="mediaIcon" />
      </div>
    );
  };

  render() {
    const { isAppointment, data } = this.state;
    const showPaymentPending = !this.isLiteVersion && data?.payment && data?.payment?.state !== "PAYED";
    const showPaymentStatus = !this.isLiteVersion && data?.payment && data?.payment?.state;
    const showLinkToWork = !this.isLiteVersion && isAppointment && data?.work_id;

    if (data) {
      return (
        <div className="main-details-container px-3 px-md-4 pt-3" id="main-details-container">
          <div className="center-container-left">
            {this.renderServiceDetailsCard()}
            {/* {this.renderVideoCallButton()} */}

            <div className="visible-desktop" id="service-tasks-list">
              {showLinkToWork && this.renderLinkToWork()}
              {showPaymentStatus && this.renderPaymentStatus()}
              {isAppointment && this.renderPaymentButton()}
              {!data.allowConfirm && !showPaymentPending && this.renderCalendarEventShare()}
              {!data.allowConfirm && !showPaymentPending && this.renderVideoCallButton()}
              {data.allowConfirm && !showPaymentPending && this.renderConfirmButton()}
              {!this.isLiteVersion && this.renderCancelAppointment()}
              {data.allowConfirm && !showPaymentPending && this.renderCalendarEventShare('small')}
              {data.allowConfirm && !showPaymentPending && this.renderVideoCallButton('small')}
              {this.renderTasksList()}
            </div>

            <div className="visible-mobile">
              {showLinkToWork && this.renderLinkToWork()}
              {showPaymentStatus && this.renderPaymentStatus()}
              {isAppointment && this.renderPaymentButton()}
              {showPaymentPending && this.renderCancelAppointment()}

              {!data.allowConfirm && this.renderRequirements()}
              <div id="internal-notes-container-mobile">{this.renderInternalObs()}</div>
            </div>
          </div>

          <div className="center-container-right" id="center-container-right">
            <div className="visible-mobile" id="service-tasks-list-mobile">

              {!data.allowConfirm && !showPaymentPending && this.renderCalendarEventShare()}
              {!data.allowConfirm && !showPaymentPending && this.renderVideoCallButton()}
              {data.allowConfirm && !showPaymentPending && this.renderConfirmButton()}
              {!this.isLiteVersion && !showPaymentPending && this.renderCancelAppointment()}
              {data.allowConfirm && !showPaymentPending && this.renderRequirements()}
              {data.allowConfirm && !showPaymentPending && this.renderCalendarEventShare()}
              {data.allowConfirm && !showPaymentPending && this.renderVideoCallButton()}
              {!isAppointment && this.renderTasksList()}
              {this.renderChecklists()}
            </div>

            <div className="visible-desktop">
              {this.renderRequirements()}
              <div id="internal-notes-container">{this.renderInternalObs()}</div>
              {this.renderChecklists()}
            </div>
            {this.renderFilesSection()}
            {this.renderMediaIcon()}
          </div>
          <Modal ref={this.refModal} />
          <Helmet>
            <title> {Helper.titleServiceDetailsPage()} </title>
          </Helmet>
        </div>
      );
    } else {
      return (
        <React.Fragment>
          <div className="main-details-container">
            <Modal ref={this.refModal} />
            <Helmet>
              <title> {Helper.titleServiceDetailsPage()} </title>
            </Helmet>
          </div>
        </React.Fragment>
      );
    }
  }
}

export default withRouter(ServiceDetails);
